module.exports = __webpack_public_path__ + "static/media/12.2b98c173.png";